import React, { useState, useEffect } from "react";
import styles from "./Inventory.module.scss";
import { ProductsTable } from "./components/ProductsTable/ProductsTable";
import { Header } from "./components/Header/Header";
import { FilterPanel } from "./components/FilterPanel/FilterPanel";
import { useGetFilters } from "../../utils/react-query/queryEcommerce/queries";
import { useFilterStore } from "../../supplierEcommerce/store";
import useCompanyStore from "../../Store/supplierCompany/companyData";

const Inventory: React.FC = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const { companyName } = useCompanyStore();
  const clearFilters = useFilterStore((state) => state.clearFilters);

  // Reset filters on mount so stale ecommerce filters don't bleed into inventory
  useEffect(() => {
    clearFilters();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const { data: filterOptions } = useGetFilters(companyName || "", { skipPriceMutation: true });

  return (
    <div className={styles.container}>
      <Header
        searchQuery={searchQuery}
        onSearchChange={setSearchQuery}
        onFilterToggle={() => setIsFilterOpen(!isFilterOpen)}
        isFilterOpen={isFilterOpen}
      />

      <div className={styles.tableContainer}>
        <ProductsTable searchQuery={searchQuery} />
      </div>

      <FilterPanel
        isOpen={isFilterOpen}
        onClose={() => setIsFilterOpen(false)}
        options={filterOptions?.filters}
      />
    </div>
  );
};

export default Inventory;
